import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {TimecardsComponent} from './timecards/timecards.component';
import {ReportsService} from './reports.service';
import {TimecardBuilderService} from './timecards-builder.service';
import {PeriodPickerComponent} from './period-selector/period-selector.component';
import {AnnualReportComponent} from './annual-report/annual-report.component';
import { Daterangepicker } from 'ng2-daterangepicker';
import {DaysCountService} from './days-count.service';


@NgModule({
	imports: [
		SharedModule,
		Daterangepicker
	],
	declarations: [
		TimecardsComponent,
		PeriodPickerComponent,
		AnnualReportComponent
	],
	exports: [],
	providers: [
		ReportsService,
		TimecardBuilderService,
		DaysCountService
	],
	entryComponents: [
		TimecardsComponent,
		AnnualReportComponent
	]
})
export class ReportsModule {}



// WEBPACK FOOTER //
// ./src/app/reports/reports.module.ts